import { formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useFormReply } from './_load/FormReplyLoader'
import FullPageMessage from '../../../../components/presentation/FullPageMessage'

const ValidateForm = () => {
  const { t } = useTranslation('listForms')
  const formReply = useFormReply()

  const formattedDate = formatDate('DD/MM/YYYY', formReply.insertedAt)

  return (
    <FullPageMessage
      icon="BsFillXCircleFill"
      iconColor="red"
      title={t('alreadyRepliedTitle')}
      description={t('alreadyRepliedDescription', { date: formattedDate })}
    />
  )
}

export default ValidateForm
